export default __webpack_public_path__ + "static/media/flor_abeja.f6fe264d.png";